//Getting the token
const getAuthToken = () => {
  return localStorage.getItem("token");
};

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const registerCustomer = async (payload) => {
  const token = getAuthToken();

  try {
    const response = await fetch(`${BASE_URL}/customers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to register customer");
    }

    return await response.json();
  } catch (err) {
    console.error("Customer registration error:", err);
    throw err;
  }
};

// Fetch customer data (GET)
export const fetchCustomers = async () => {
  const token = getAuthToken();

  try {
    const response = await fetch(`${BASE_URL}/customers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch customers");
    }

    return await response.json();
  } catch (err) {
    console.error("Customer fetch error:", err);
    throw err;
  }
};
